/* eslint-disable react/jsx-filename-extension */
// <reference path='./index.d.ts'/>
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unregister } from './registerServiceWorker';
import App from './App';
import './index.css';
import './styles/primary-color-override.css';
// import './semantic/dist/semantic.min.css'; // Moved to CDN to avoid asset handling issues
// Redux
import store from './config/store';
// Chart.js configuration
import './config/chart';

const container = document.getElementById('root') as HTMLElement;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);

unregister();
